/**
 * These need to match the PromoCodeTypes class from the API
 *
 * @see app\Models\PromoCodeTypes.php
 */
export const PROMO_CODE_TYPES = {
	AMOUNT: 'amount',
	AMOUNT_OVER: 'amount_over',
	AMOUNT_PRODUCT: 'amount_product',
	PERCENT: 'percent',
	PERCENT_OVER: 'percent_over',
	PERCENT_PRODUCT: 'percent_product'
};
